/**
 * Central source of truth for legal-document URLs surfaced across the
 * web portal (login footer, sidebar, signup T&Cs, etc.).
 *
 * Hosted on Termly — changes to the policy text take effect immediately
 * without a redeploy. Update the `policyUUID` query param if a document
 * is ever replaced wholesale. Kept in lockstep with the Flutter app's
 * `crop-swipe/lib/core/constants/legal_urls.dart`.
 */
export const LEGAL_URLS = {
  privacyPolicy:
    'https://www.americandronenetwork.com/privacy-policy/',
  termsOfUse:
    'https://www.americandronenetwork.com/terms-conditions/',
} as const;
